import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AgentCustomConfigModel } from '@smarttask-common/src/lib/models/Agent/Config/AgentCustomConfigModel';

export enum AgentCustomActionTypes {
    ADD_AGENT = '[AgentCustom] Add Agent',
    ADD_AGENTS = '[AgentCustom] Add Agents',
    UPSERT_AGENT = '[AgentCustom] Upsert Agent',
    UPSERT_AGENTS = '[AgentCustom] Upsert Agents',
    UPDATE_AGENT = '[AgentCustom] Update Agent',
    UPDATE_AGENTS = '[AgentCustom] Update Agents',
    DELETE_AGENT = '[AgentCustom] Delete Agent',
    DELETE_AGENTS = '[AgentCustom] Delete Agents',
    DELETE_ALL = '[AgentCustom] Delete All',
}

export class AddOne implements Action {
    readonly type = AgentCustomActionTypes.ADD_AGENT;
    constructor(public agent: AgentCustomConfigModel) {}
}

export class AddMany implements Action {
    readonly type = AgentCustomActionTypes.ADD_AGENTS;
    constructor(public agents: Array<AgentCustomConfigModel>) {}
}

export class UpsertOne implements Action {
    readonly type = AgentCustomActionTypes.UPSERT_AGENT;
    constructor(public agent: AgentCustomConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = AgentCustomActionTypes.UPSERT_AGENTS;
    constructor(public agents: Array<AgentCustomConfigModel>) {}
}

export class UpdateOne implements Action {
    readonly type = AgentCustomActionTypes.UPDATE_AGENT;
    constructor(public agent: Update<AgentCustomConfigModel>) {}
}

export class UpdateMany implements Action {
    readonly type = AgentCustomActionTypes.UPDATE_AGENTS;
    constructor(public agents: Array<Update<AgentCustomConfigModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = AgentCustomActionTypes.DELETE_AGENT;
    constructor(public id: number) {}
}

export class DeleteMany implements Action {
    readonly type = AgentCustomActionTypes.DELETE_AGENTS;
    constructor(public ids: Array<number>) {}
}

export class DeleteState implements Action {
    readonly type = AgentCustomActionTypes.DELETE_ALL;
    constructor() {}
}

export type AgentCustomActions = AddOne | AddMany | UpsertOne | UpsertMany | DeleteOne | DeleteMany | DeleteState | UpdateOne | UpdateMany;
